import { api as r } from "../utils/configuration.js";
import { crudService as i } from "../js/request-DH6Y2P3c.js";
const m = (o) => i.post(o, `${r.OAUTH_URL}/login`);
export {
  m as login
};
//# sourceMappingURL=login.js.map
